module.exports = __webpack_public_path__ + "img/svg_2.8b9c188b.png";